import React, { useMemo } from 'react';
import { MultiSpanTable } from '../MultiSpanTable';
import { humanPropertyName } from 'components/account/jobs/utils';
import { captureTypeMap } from 'models/jobs/jobs';
import { humanIdType } from 'utils/jobs';
export const buildDeviceData = (jobResult, jobRequestInfo) => ({
    client: jobResult?.clientOutput?.client,
    referer: jobRequestInfo?.referer,
    theme: jobResult?.clientOutput?.theme,
    userAgent: jobRequestInfo?.useragent,
    ipAddress: jobRequestInfo?.ipaddress
});
export const buildSubmittedData = (params) => ({
    dob: params?.dob,
    email: params?.email,
    firstName: params?.firstName,
    lastName: params?.lastName,
    phone: params?.phone
});
export const buildExtractedData = (jobResult) => ({
    address: jobResult.address ?? jobResult.unverifiedIdAddress,
    birthDate: jobResult.birthDate,
    captureType: jobResult.clientOutput?.capture?.id,
    class: jobResult.class,
    country: jobResult.country,
    endorsements: jobResult.endorsements,
    expireDate: jobResult.expireDate,
    firstName: jobResult.firstName,
    id: jobResult.id,
    issueDate: jobResult.issueDate,
    lastName: jobResult.lastName,
    middleName: jobResult.middleName ?? undefined,
    motorcycle: jobResult.motorcycle,
    state: jobResult.state,
    type: jobResult.type
});
export const IDVDetailsTable = ({ extractedData, submittedData, deviceData, properties, header = 'Details' }) => {
    const entries = useMemo(() => [
        ...(extractedData
            ? [
                {
                    title: 'Extracted',
                    items: [
                        { label: 'First Name', value: extractedData.firstName },
                        { label: 'Middle Name', value: extractedData.middleName },
                        { label: 'Last Name', value: extractedData.lastName },
                        { label: 'Birth Date', value: extractedData.birthDate },
                        {
                            label: 'Type',
                            value: humanIdType(extractedData.type) ?? undefined
                        },
                        {
                            label: 'Capture Type',
                            value: extractedData.captureType
                                ? captureTypeMap[extractedData.captureType]
                                : undefined
                        },
                        { label: 'ID Number', value: extractedData.id },
                        { label: 'Address', value: extractedData.address },
                        { label: 'Country', value: extractedData.country },
                        { label: 'State', value: extractedData.state },
                        { label: 'Expiration Date', value: extractedData.expireDate },
                        { label: 'Issue Date', value: extractedData.issueDate },
                        { label: 'Class', value: extractedData.class },
                        { label: 'Endorsements', value: extractedData.endorsements },
                        { label: 'Motorcycle', value: extractedData.motorcycle }
                    ]
                }
            ]
            : []),
        ...(submittedData
            ? [
                {
                    title: 'Submitted',
                    items: [
                        { label: 'First Name', value: submittedData.firstName },
                        { label: 'Last Name', value: submittedData.lastName },
                        { label: 'Birth Date', value: submittedData.dob },
                        { label: 'Email', value: submittedData.email },
                        { label: 'Phone', value: submittedData.phone }
                    ]
                }
            ]
            : []),
        {
            title: 'Device',
            items: [
                {
                    label: 'Referer',
                    value: deviceData.referer
                },
                {
                    label: 'User Agent',
                    value: deviceData.userAgent
                },
                {
                    label: 'Theme',
                    value: deviceData.theme
                },
                {
                    label: 'Client',
                    value: deviceData.client
                },
                {
                    label: 'IP Address',
                    value: deviceData.ipAddress
                }
            ]
        },
        ...(properties && properties.length > 0
            ? [
                {
                    title: 'Properties',
                    items: properties.map((property) => {
                        return {
                            label: property.name in humanPropertyName
                                ? humanPropertyName[property.name]
                                : property.name,
                            value: property.value
                        };
                    })
                }
            ]
            : [])
    ], [extractedData, submittedData, deviceData, properties]);
    return React.createElement(MultiSpanTable, { entries: entries, header: header });
};
